import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { CustomerNumber, VriAPIResponse, VriAPIResult } from '../types';

interface GetCustomerNumberResult extends VriAPIResult {
    data?: {
        customerNumbers: CustomerNumber[];
    };
}

interface GetCustomerNumberResponse extends VriAPIResponse {
    data: {
        numbers: CustomerNumber[];
    };
}

// eslint-disable-next-line import/prefer-default-export
export async function getCustomerNumber(userId: string): Promise<GetCustomerNumberResult> {
    const result = {} as GetCustomerNumberResult;
    try {
        const { data: responseData } = await axios.post<GetCustomerNumberResponse>(
            END_POINT.GET_CUSTOMER_NUMBER,
            { userId },
        );
        result.data = {
            customerNumbers: responseData.data.numbers,
        };
    } catch (error) {
        result.error = error;
    }
    return result;
}
